import script from "./LoginPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginPage.vue?vue&type=script&setup=true&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=6c1151c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c1151c0"]])

export default __exports__